/**
 * VerticalLayoutContainer Component
 * Orchestrates the new vertical flow layout for improved results visibility
 * Replaces the side-by-side grid layout with a progressive disclosure approach
 */

import React from 'react'
import styles from './VerticalLayoutContainer.module.css'

interface VerticalLayoutContainerProps {
  children: React.ReactNode
  className?: string
  maxWidth?: number
  spacing?: 'compact' | 'normal' | 'spacious'
}

const VerticalLayoutContainer: React.FC<VerticalLayoutContainerProps> = ({
  children,
  className = '',
  maxWidth = 800,
  spacing = 'normal'
}) => {
  const containerStyle = {
    '--max-width': `${maxWidth}px`
  } as React.CSSProperties

  return (
    <div 
      className={`${styles.verticalLayout} ${styles[spacing]} ${className}`}
      style={containerStyle}
    >
      {children}
    </div>
  )
}

export default VerticalLayoutContainer